import { useLocation } from "react-router-dom";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";

const TITLES = {
  "/mentions-legales": ["[ Légal ]", ["Mentions", "légales."]],
  "/confidentialite": ["[ Légal ]", ["Politique de", "confidentialité."]],
  "/cgu": ["[ Légal ]", ["Conditions", "d'utilisation."]],
  "/cgv": ["[ Légal ]", ["Conditions de", "vente."]],
};

export default function Legal() {
  const { pathname } = useLocation();
  const [eyebrow, titleLines] = TITLES[pathname] || ["[ Légal ]", ["Document", "légal."]];

  return (
    <>
      <PageHeader eyebrow={eyebrow} titleLines={titleLines} />
      <section className="bg-paper py-20 md:py-28" data-testid="legal-page">
        <div className="mx-auto max-w-3xl px-5 md:px-10">
          <Reveal>
            <div className="rounded-sm border hairline bg-white p-8 md:p-12">
              <span className="label-mono text-gold">En cours de rédaction</span>
              <p className="font-display text-2xl md:text-3xl font-medium mt-4 leading-snug text-ink">
                Ce document est en cours de finalisation.
              </p>
              <p className="text-ink/60 mt-5">
                Les informations légales officielles de Nova Lean Consulting (raison sociale, SIREN, capital,
                hébergeur, etc.) seront publiées ici dès leur validation. Pour toute question,
                contactez-nous à <a href="mailto:novalean26@outlook.fr" className="text-ink font-semibold link-underline">novalean26@outlook.fr</a>.
              </p>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
